import { each } from "fxjs/es";
import { TransformManipulator } from "../public/TransformManipulator.js";
export const endSelectionScaleTransform = ({ els, transform_manipulator }) => {
  const is_multiple = els.length > 1;
  each((el) => {
    is_multiple
      ? transform_manipulator.mergeExtendedTransformToFixed(el)
      : transform_manipulator.mergeExtendedTransformToBase(el);
    el.dispatchEvent(
      new CustomEvent(`@mp/sticker-editor/transform`, {
        bubbles: true,
        cancelable: true,
        composed: false,
        detail: {
          el,
          transform_type: "scale",
          transform_status: "end",
        },
      })
    );
  })(els);
};
